// Estimated time left of a running background job, from the speed so far ("about 12 min left"), or null while there
// is too little data for a sensible guess. The server's own timestamps are used, so a wrong clock in the browser
// does not matter. A job that waited for Strava's rate limit looks slower than it is, so the estimate then errs high.
export function formatEta(job) {
  if (!job || job.status !== 'running' || !job.total || !job.startedAt || !job.updatedAt) return null;
  const elapsedS = (new Date(job.updatedAt) - new Date(job.startedAt)) / 1000;
  if (!(job.done >= 10) || !(elapsedS >= 20)) return null;
  const secondsLeft = ((job.total - job.done) * elapsedS) / job.done;
  if (secondsLeft < 45) return 'less than a minute left';
  const minutes = Math.round(secondsLeft / 60);
  if (minutes < 90) return `about ${minutes} min left`;
  return `about ${Math.round(minutes / 6) / 10} hours left`;
}
